import React from "react";
import Img from "gatsby-image";
import { Link } from "gatsby";
import { stringify } from "query-string";

const ComparisonCard = ({ path, boards }) => {
  const idsString = stringify(
    { ids: boards.map(board => board.id) },
    { arrayFormat: "comma" }
  );

  return (
    <Link
      to={`${path}?${idsString}`}
      className="flex justify-between items-start comparisonCard relative p-4 rounded-md border focus:outline-none focus:shadow-outline"
    >
      <div className="comparisonCard__board1 w-24 md:w-32">
        <div className="flex justify-center mb-3">
          <Img
            fluid={boards[0].thumbnail.childImageSharp.fluid}
            className="w-full h-20 md:h-24"
          />
        </div>
        <h3 className="text-center text-sm pt-2 border-t">{boards[0].title}</h3>
      </div>
      <span
        style={{ transform: "translate(-50%,-50%)" }}
        className="absolute top-1/2 left-1/2 h-6 w-6 text-sm text-gray-700 flex justify-center items-center bg-gray-300 rounded-full"
      >
        vs
      </span>
      <div className="comparisonCard__board2 w-24 md:w-32">
        <div className="flex justify-center mb-3">
          <Img
            fluid={boards[1].thumbnail.childImageSharp.fluid}
            className="w-full h-20 md:h-24"
          />
        </div>
        <h3 className="text-center text-sm pt-2 border-t">{boards[1].title}</h3>
      </div>
    </Link>
  );
};

export default ComparisonCard;
